module.exports = __webpack_public_path__ + "static/img/机器人悬浮窗_image@2x.1aeb3832.png";